import React, { useState } from 'react'
import { Button, List, NavBar, Switch } from 'antd-mobile'
import { CloseOutline } from 'antd-mobile-icons'
import { useNavigate } from 'react-router-dom'
import { useRecoilState, useRecoilValue } from 'recoil'
import { deviceRecoil } from '../../../recoils/device'
import { Contact, contactsSelector } from '../../../recoils/contacts'
import { getCookie } from 'react-use-cookie'
import { useTranslation } from 'react-i18next'

const EditDeviceContacts: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const organization = getCookie('organization')
  const deviceId = getCookie('deviceId')

  const [device, setDevice] = useRecoilState(deviceRecoil({ organizationId: organization, deviceId: deviceId }))
  const [contacts, setContacts] = useState(device.client.current.contacts || [])

  const contactList = useRecoilValue(contactsSelector({ organizationId: organization, deviceIdCurrent: deviceId }))

  const handleChangeContact = (value: boolean, contact: Contact) => {
    if (value) {
      setContacts(
        contacts.concat({
          id: contact.id,
          avatar: contact?.avatar || '',
          displayName: contact?.displayName || '',
        })
      )
    } else {
      setContacts(([...contacts]) => {
        const contactIndex = contacts.findIndex((contactOld) => contactOld.id === contact.id)
        contacts.splice(contactIndex, 1)
        return contacts
      })
    }
  }

  const handleEditDeviceContacts = () => {
    setDevice({
      ...device,
      client: { ...device.client, current: { ...device.client.current, contacts } },
    })
    navigate('/device/detail')
  }

  return (
    <div className="container">
      <NavBar
        className="fixed-top"
        style={{ '--border-bottom': '1px solid #EEEEEE', height: '55px' }}
        right={
          <Button fill="none" onClick={() => navigate('/')}>
            <CloseOutline color="#111827" />
          </Button>
        }
        onBack={() => navigate('/device/detail')}
      >
        {t('device.edit.contacts.title')}
      </NavBar>
      <List header={t('device.edit.contacts.list')} style={{ '--border-top': 'none', padding: '75px 25px 20px' }}>
        {contactList.map((contact, index) => (
          <List.Item
            key={index}
            extra={
              <Switch defaultChecked={contact.callStatus} onChange={(value) => handleChangeContact(value, contact)} />
            }
          >
            {contact.displayName}
          </List.Item>
        ))}
      </List>
      <List style={{ '--border-top': 'none', '--border-bottom': 'none', padding: '20px' }}>
        <List.Item>
          <Button
            color="primary"
            fill="solid"
            style={{ width: '100%', marginTop: '20px' }}
            onClick={handleEditDeviceContacts}
          >
            {t('device.edit.contacts.button.save')}
          </Button>
        </List.Item>
      </List>
    </div>
  )
}

export default EditDeviceContacts
